import axios from "axios";

const guardarCategoriaService = async (nombre) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/productos/categorias`,
            { nombre },
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

const editarCategoriaService = async (id, nombre) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/productos/categorias/${id}`,
            { nombre },
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    guardarCategoriaService,
    editarCategoriaService
}